// extracted by mini-css-extract-plugin
export default {"carousel-item":"CarouselItem_carousel-item__qBsA5","item-name":"CarouselItem_item-name__zFaay"};